import { useRecoilState } from "recoil";
import { ModalTypeState, SelectedCustomerState } from "../../atoms";
import { BaseModal } from "./BaseModal";
import { CustomersClient } from "../../services";
import { GetNewInstance } from "../../helpers/HttpCommon";
import { ModalTypes } from "./ModalTypes";

type Props = {
  onSuccess: () => void;
};

export function ArchiveCustomerModal({ onSuccess }: Props) {
  const [, setModalType] = useRecoilState(ModalTypeState);
  const [selectedCustomer, setSelectedCustomer] = useRecoilState(
    SelectedCustomerState
  );

  const client = new CustomersClient(undefined, GetNewInstance());

  const onCancel = () => {
    setSelectedCustomer(null);
    setModalType(null);
  };

  const onArchiveClick = () => {
    selectedCustomer?.id &&
      client.archiveCustomer(selectedCustomer?.id).then((x) => {
        onSuccess();
        setSelectedCustomer(null);
        setModalType(null);
      });
  };

  return (
    <BaseModal
      id={ModalTypes.ArchiveCustomerModal}
      title="Archive customer"
      description={
        "Are you sure you want to archive " + selectedCustomer?.name + "?"
      }
    >
      <div className="py-4 text-sm text-white">
        <div className="mt-8 flex justify-end gap-4">
          <button
            onClick={onCancel}
            className="py-2.5 px-4 rounded-md border border-page-border bg-white bg-opacity-5 hover:bg-opacity-10"
          >
            Cancel
          </button>
          <button
            onClick={onArchiveClick}
            className="py-2.5 px-4 rounded-md bg-button-bg-destructive-default hover:bg-button-bg-destructive-hover active:shadow-button-bg-destructive-default"
          >
            Archive
          </button>
        </div>
      </div>
    </BaseModal>
  );
}
